import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <FaqSection />
        <FeaturesSection />
        <CarouselSection />
        <AboutSection />
        <CommentsSection />
        <AppSection />
        <TopicsSection />
        <ContactSection />
        <UpdatesSection />
        <RankingSection />
        <MediaSection />
        <CardsSection />
      </main>
      <Footer />
    </div>
  );
}